import rateShopperIcon from '../svgs/rate-shopper-icon.svg';
import automationRulesIcon from '../svgs/automation-icon.svg';
// import insightsIcon from '../svgs/insights-icon.svg';
import warehouseIcon from '../svgs/warehouse-icon.svg';
import inventoryIcon from '../svgs/inventory-icon.svg';
import returnsWithArrowIcon from '../svgs/returns-icon.svg';
// import shirtIcon from '../svgs/shirt-icon.svg';
import brandingIcon from '../svgs/branding-icon.svg';

import messages from './messages';

export const featureCardsData = [
  {
    id: 'rate-shopping',
    title: messages.rateShoppingTitle.defaultMessage,
    description: messages.rateShoppingDescription.defaultMessage,
    icon: rateShopperIcon,
  },
  {
    id: 'automation-rules',
    title: messages.automationRulesTitle.defaultMessage,
    description: messages.automationRulesDescription.defaultMessage,
    icon: automationRulesIcon,
  },
  {
    id: 'branding',
    title: messages.brandingTitle.defaultMessage,
    description: messages.brandingDescription.defaultMessage,
    icon: brandingIcon,
  },
  {
    id: 'returns',
    title: messages.returnsTitle.defaultMessage,
    description: messages.returnsDescription.defaultMessage,
    icon: returnsWithArrowIcon,
  },
  {
    id: 'inventory',
    title: messages.inventoryTitle.defaultMessage,
    description: messages.inventoryDescription.defaultMessage,
    icon: inventoryIcon,
  },
  {
    id: 'warehouse',
    title: messages.warehouseTitle.defaultMessage,
    description: messages.warehouseDescription.defaultMessage,
    icon: warehouseIcon,
  },
  // TODO: Commented out these 2 features until the Pendos are ready - Greg Smith 7/7/25
  // {
  //   id: 'insights',
  //   title: messages.insightsTitle.defaultMessage,
  //   description: messages.insightsDescription.defaultMessage,
  //   icon: insightsIcon,
  // },
  // {
  //   id: 'fulfillment',
  //   title: messages.fulfillmentTitle.defaultMessage,
  //   description: messages.fulfillmentDescription.defaultMessage,
  //   icon: shirtIcon,
  // },
];
